/**
 * The "Copy details" bundle for a screen that broke — the same DiagnosticBundle (and so the same Markdown)
 * as Admin → Health's Copy diagnostic: the fixed preamble, the error, the page's last requests.
 */
import { DIAGNOSTIC_PREAMBLE, type DiagnosticBundle } from '@shared/admin';
import { recentClientLog } from './busy';

export interface BuildInfo {
  app: string;
  sha: string;
  builtAt: string;
}

export function screenErrorBundle(error: Error, componentStack: string, language: string, build: BuildInfo, now = new Date()): DiagnosticBundle {
  const where = typeof window === 'undefined' ? '' : window.location.pathname;
  const detail = [`Route: ${where}`, ...(error.stack ?? '').split('\n').slice(0, 8), ...componentStack.trim().split('\n').slice(0, 6).map((l) => l.trim())]
    .filter(Boolean)
    .join('\n');
  return {
    preamble: DIAGNOSTIC_PREAMBLE.replace('The health check below failed.', 'A screen stopped with the error below.'),
    generatedAt: now.toISOString(),
    environment: typeof window === 'undefined' ? 'unknown' : window.location.host,
    version: { ...build, node: 'browser' },
    checks: [],
    check: { key: 'screen', status: 'red', message: `${error.name}: ${error.message}`.slice(0, 300), detail },
    config: {
      route: where,
      language,
      browser: typeof navigator === 'undefined' ? '' : navigator.userAgent,
    },
    log: recentClientLog(),
  };
}
